// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zj4A","top":"styles_top__a3laL"};